export const DEFAULT_TIMEOUT_MS = 60_000 // 1 minute
export const JUPYTER_PORT = 49999
